export interface DateRange { start: string; end: string }
export type DatePreset = 'today' | 'yesterday' | '7' | '30' | '90' | 'month' | 'lastMonth' | 'year' | 'custom';
export const DATE_PRESETS: { value: DatePreset; label: string }[] = [
  { value: 'today', label: 'Bugün' }, { value: 'yesterday', label: 'Dün' },
  { value: '7', label: 'Son 7 gün' }, { value: '30', label: 'Son 30 gün' },
  { value: '90', label: 'Son 90 gün' }, { value: 'month', label: 'Bu ay' },
  { value: 'lastMonth', label: 'Geçen ay' }, { value: 'year', label: 'Bu yıl' },
  { value: 'custom', label: 'Özel tarih' },
];
export function istanbulDay(now = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
}
function iso(d: Date) { return d.toISOString().slice(0, 10); }
export function presetRange(preset: Exclude<DatePreset, 'custom'>, now = new Date()): DateRange {
  const end = new Date(`${istanbulDay(now)}T12:00:00Z`);
  const start = new Date(end);
  if (preset === 'yesterday') { start.setUTCDate(start.getUTCDate() - 1); end.setUTCDate(end.getUTCDate() - 1); }
  else if (preset === 'month') start.setUTCDate(1);
  else if (preset === 'lastMonth') { start.setUTCDate(1); start.setUTCMonth(start.getUTCMonth() - 1); end.setUTCDate(0); }
  else if (preset === 'year') { start.setUTCMonth(0, 1); }
  else if (preset !== 'today') start.setUTCDate(start.getUTCDate() - Number(preset) + 1);
  return { start: iso(start), end: iso(end) };
}
export function rangeError(range: DateRange): string | null {
  if (!range.start || !range.end) return 'Başlangıç ve bitiş tarihini seçin.';
  const days = (Date.parse(range.end) - Date.parse(range.start)) / 86400000 + 1;
  if (!Number.isFinite(days) || days < 1) return 'Bitiş tarihi başlangıçtan önce olamaz.';
  if (days > 366) return 'En fazla 366 günlük aralık seçebilirsiniz.';
  if (range.end > istanbulDay()) return 'Gelecek tarih seçilemez.';
  return null;
}
